module.exports = __webpack_public_path__ + "img/Kalsiy_D3_1280x1010.519e687a.jpg";